<template>
    <div class="tw-space-y-2">
        <div
            class="hover:tw-shadow-md tw-border tw-cursor-pointer tw-border-gray-300 tw-mb-4 tw-rounded-md tw-overflow-hidden tw-mx-auto tw-w-48 tw-h-48"
        >
            <div class="tw-w-full tw-h-full tw-relative">
                <label
                    for="logo-image"
                    class="tw-w-full tw-h-full tw-cursor-pointer tw-absolute tw-top-0"
                >
                    <img
                        id="logo"
                        class="tw-w-full tw-h-full tw-object-contain"
                        :src="logo_file_src"
                        alt
                    />
                </label>
            </div>
            <input
                type="file"
                id="logo-image"
                ref="logoimage"
                style="display:none"
                @change="onFileChange"
            />
        </div>
        <div class="row">
            <div class="col-md-12">
                <label class="tw-text-xs required">{{
                    $t("bankProfile.bankName")
                }}</label>
                <input
                    v-model="model.bank_name"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('bank_name') }"
                />
                <div
                    class="invalid-feedback tw-text-xs"
                    v-if="errors.has('bank_name')"
                >
                    {{ errors.first("bank_name") }}
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <label class="required tw-text-xs">{{
                    $t("bankProfile.accountNumber")
                }}</label>
                <div
                    class="tw-border tw-border-blue-300 tw-rounded tw-p-2 tw-relative"
                >
                    <div
                        class="overflow-auto"
                        style="min-height: 300px; max-height: 400px"
                    >
                        <table>
                            <thead>
                                <tr
                                    class="tw-uppercase tw-bg-gray-200 tw-sticky tw-top-0"
                                >
                                    <th
                                        class="tw-p-1 tw-border-white tw-border"
                                        style="width: 20%"
                                    >
                                        <label class="tw-m-0">{{
                                            $t("bankProfile.prefix")
                                        }}</label>
                                    </th>
                                    <th
                                        class="tw-p-1 tw-border-white tw-border"
                                    >
                                        <label class="required tw-m-0">{{
                                            $t("bankProfile.accountNumber")
                                        }}</label>
                                    </th>
                                    <th
                                        class="tw-p-1 tw-border-white tw-border"
                                    >
                                        <label class="required tw-m-0">{{
                                            $t("bankProfile.accountName")
                                        }}</label>
                                    </th>
                                    <th
                                        class="tw-p-1 tw-border-white tw-border tw-text-center"
                                        style="width: 5%"
                                    >
                                        <a
                                            href="#"
                                            class="text-primary"
                                            @click.prevent="addAccount"
                                        >
                                            <i class="fas fa-plus"></i>
                                        </a>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(a, index) in model.account_number"
                                    :key="index"
                                >
                                    <td
                                        class="tw-p-1 tw-border-white tw-border tw-align-top"
                                    >
                                        <input
                                            v-model.trim="a.prefix"
                                            type="text"
                                            class="form-control"
                                            :placeholder="
                                                $t('bankProfile.prefix')
                                            "
                                            :class="{
                                                'is-invalid': errors.has(
                                                    'account_number.' +
                                                        index +
                                                        '.prefix'
                                                )
                                            }"
                                        />
                                    </td>
                                    <td
                                        class="tw-p-1 tw-border-white tw-border"
                                    >
                                        <input
                                            v-model.trim="a.account_number"
                                            type="text"
                                            class="form-control"
                                            :placeholder="
                                                $t('bankProfile.accountNumber')
                                            "
                                            :class="{
                                                'is-invalid': errors.has(
                                                    'account_number.' +
                                                        index +
                                                        '.account_number'
                                                )
                                            }"
                                        />
                                    </td>
                                    <td
                                        class="tw-p-1 tw-border-white tw-border"
                                    >
                                        <input
                                            v-model.trim="a.account_name"
                                            type="text"
                                            class="form-control"
                                            :placeholder="
                                                $t('bankProfile.accountName')
                                            "
                                            :class="{
                                                'is-invalid': errors.has(
                                                    'account_number.' +
                                                        index +
                                                        '.account_name'
                                                )
                                            }"
                                        />
                                    </td>
                                    <td
                                        class="tw-p-1 tw-border-white tw-border tw-text-center"
                                    >
                                        <a
                                            href="#"
                                            class="text-danger"
                                            @click.prevent="remove(index)"
                                        >
                                            <i class="fa fa-trash"></i>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <label class="tw-text-xs">{{
                    $t("bankProfile.description")
                }}</label>
                <textarea
                    rows="3"
                    class="form-control"
                    v-model.trim="model.description"
                ></textarea>
                <div
                    class="invalid-feedback tw-text-xs"
                    v-if="errors.has('description')"
                >
                    {{ errors.first("description") }}
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 tw-mt-3 tw-text-right tw-space-x-2">
                <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
                    {{ $t("cancel") }}
                </ts-button>
                <ts-button
                    v-if="!isUpdate"
                    color="primary"
                    @click.prevent="onSave"
                    :waiting="waiting"
                    >{{ $t("save") }}</ts-button
                >
                <ts-button
                    v-if="isUpdate"
                    color="primary"
                    @click.prevent="onUpdate"
                    :waiting="waiting"
                    >{{ $t("update") }}</ts-button
                >
            </div>
        </div>
    </div>
</template>

<script>
import { Errors } from "form-backend-validation";
import { mapState } from "vuex";
import { isEmpty } from "lodash";

export default {
    name: "bankProfileForm",
    data() {
        return {
            errors: new Errors(),
            waiting: false,
            waiting_new: false,
            logo_file: null,
            logo_file_src: require("@/assets/default-logo.jpg"),
            model: {
                bank_id: 0,
                bank_name: null,
                description: null,
                bank_logo: null,
                account_number: [
                    {
                        prefix: null,
                        account_number: null,
                        account_name: null
                    }
                ]
            }
        };
    },
    computed: {
        ...mapState("corporate/bankProfile", ["edit_data"]),
        isUpdate() {
            return !isEmpty(this.edit_data);
        }
    },
    methods: {
        onFileChange() {
            const file = this.$refs.logoimage.files[0];
            let reader = new FileReader();
            reader.addEventListener(
                "load",
                function() {
                    this.logo_file_src = reader.result;
                }.bind(this),
                false
            );
            if (file) {
                if (/\.(jpe?g|png)$/i.test(file.name)) {
                    reader.readAsDataURL(file);
                    this.logo_file = file;
                } else {
                    this.logo_file_src = require("@/assets/default-logo.jpg");
                    this.$toasted.error("invalid file type!");
                    this.$refs.logo_file.value = "";
                }
            }
        },
        async uploadLogo() {
            if ((this.logo_file instanceof File) | Blob) {
                let formData = new FormData();
                formData.append("file", this.logo_file);
                let response = await this.$store.dispatch(
                    "corporate/bankProfile/upload",
                    formData
                );
                this.model.bank_logo = response;
            }
            return "";
        },
        addAccount() {
            this.model.account_number.push({
                prefix: null,
                account_number: null,
                account_name: null
            });
        },
        remove(index) {
            this.model.account_number.splice(index, 1);
        },
        async onSave() {
            this.waiting = true;
            await this.uploadLogo();
            this.$store
                .dispatch("corporate/bankProfile/store", this.model)
                .then(response => {
                     this.notice({
                        type: 'success',
                        text: response.message
                    })
                    this.$emit("fetchData");
                    this.$emit("cancel");
                })
                .catch(error => {
                    this.notice({ type: 'error', text: error.message })
                    this.errors = new Errors(error.errors);
                })
                .finally(() => {
                    this.waiting = false;
                });
        },
        async onUpdate() {
            this.waiting = true;
            await this.uploadLogo();
            this.$store
                .dispatch("corporate/bankProfile/update", {
                    id: this.model.bank_id,
                    data: this.model
                })
                .then(response => {
                     this.notice({
                        type: 'success',
                        text: response.message
                    })
                    this.$emit("fetchData");
                    this.$emit("cancel");
                })
                .catch(error => {
                    this.notice({ type: 'error', text: error.message })
                    this.errors = new Errors(error.errors);
                })
                .finally(() => {
                    this.waiting = false;
                });
        },
        setEditData() {
            if (!isEmpty(this.edit_data)) {
                this.model.bank_id = this.edit_data.bank_id;
                this.model.bank_name = this.edit_data.bank_name;
                this.model.description = this.edit_data.description;
                this.model.bank_logo = this.edit_data.bank_logo;
                if (this.edit_data.bank_logo) {
                    this.logo_file_src = this.edit_data.bank_logo;
                }
                this.model.account_number = this.edit_data.accounts.map(el => ({
                    prefix: el.prefix,
                    account_number: el.account_number,
                    account_name: el.account_name
                }));
            }
        },
        clearInput () {
            this.errors = new Errors()
            this.model = {
                bank_id: 0,
                bank_name: null,
                description: null,
                bank_logo: null,
                account_number: [
                    {
                        prefix: null,
                        account_number: null,
                        account_name: null
                    }
                ]
            }
            this.logo_file = null
            this.logo_file_src = require("@/assets/default-logo.jpg")
        },
        notice (not) {
            this.$Notice[not.type]({
                title: 'BANK PROFILE',
                desc: not.text
            })
        }
    }
};
</script>
